import { isDev } from 'src/environmentVariables/EnvironmentVariables';
import { PostHogCapture } from 'src/hooks/posthog/usePostHogCapture';

interface NonMarketOrderTimingData {
	ixCreationStartTime: number | null;
	ixCreationEndTime: number | null;
	txBuildingStartTime: number | null;
	txBuildingEndTime: number | null;
	feePayerSigningStartTime: number | null;
	feePayerSigningEndTime: number | null;
	embeddedWalletSigningStartTime: number | null;
	embeddedWalletSigningEndTime: number | null;
	sendTransactionStartTime: number | null;
	sendTransactionEndTime: number | null;
}

interface NonMarketOrderTimingParams {
	startTime: number;
	timingData: NonMarketOrderTimingData;
	marketIndex: number;
	orderType: string | undefined;
	baseAmount: number;
	captureEvent: PostHogCapture;
}

export const logNonMarketOrderTimingMetrics = ({
	startTime,
	timingData,
	marketIndex,
	orderType,
	baseAmount,
	captureEvent,
}: NonMarketOrderTimingParams): void => {
	const overallTime = Date.now() - startTime;
	const ixCreationTime =
		timingData.ixCreationStartTime && timingData.ixCreationEndTime
			? timingData.ixCreationEndTime - timingData.ixCreationStartTime
			: null;
	const txBuildingTime =
		timingData.txBuildingStartTime && timingData.txBuildingEndTime
			? timingData.txBuildingEndTime - timingData.txBuildingStartTime
			: null;
	const feePayerSigningTime =
		timingData.feePayerSigningStartTime && timingData.feePayerSigningEndTime
			? timingData.feePayerSigningEndTime - timingData.feePayerSigningStartTime
			: null;
	const embeddedWalletSigningTime =
		timingData.embeddedWalletSigningStartTime &&
		timingData.embeddedWalletSigningEndTime
			? timingData.embeddedWalletSigningEndTime -
				timingData.embeddedWalletSigningStartTime
			: null;
	const sendTransactionTime =
		timingData.sendTransactionStartTime && timingData.sendTransactionEndTime
			? timingData.sendTransactionEndTime - timingData.sendTransactionStartTime
			: null;

	isDev() &&
		console.log(
			JSON.stringify(
				{
					ix_creation_time_ms: ixCreationTime,
					tx_building_time_ms: txBuildingTime,
					fee_payer_signing_time_ms: feePayerSigningTime,
					embedded_wallet_signing_time_ms: embeddedWalletSigningTime,
					send_transaction_time_ms: sendTransactionTime,
					overall_time_ms: overallTime,
					market_index: marketIndex,
					order_type: orderType ?? 'unknown',
					base_amount: baseAmount,
				},
				null,
				2
			)
		);

	captureEvent('perp_non_market_order_timing', {
		ix_creation_time_ms: ixCreationTime,
		tx_building_time_ms: txBuildingTime,
		fee_payer_signing_time_ms: feePayerSigningTime,
		embedded_wallet_signing_time_ms: embeddedWalletSigningTime,
		send_transaction_time_ms: sendTransactionTime,
		overall_time_ms: overallTime,
		market_index: marketIndex,
		order_type: orderType ?? 'unknown',
		base_amount: baseAmount,
	});
};
